import type { API } from '@/services/ant-design-pro/typings';
import type { AdminUser } from '@/stores/authStore';
import { isSuperadminRole } from '@/utils/permissions';

/** Map persisted admin user → Umi `initialState.currentUser` shape. */
export function adminUserToCurrentUser(user: AdminUser): API.CurrentUser {
  return {
    name: user.name,
    email: user.email,
    userid: user._id,
    access: isSuperadminRole(user.role) ? 'admin' : user.role,
    role: user.role,
    _id: user._id,
    permissions: user.permissions,
    isActive: user.isActive,
  };
}
